{
  "name": "17-Ibn Sina",
  "description": "17-tone 13-Limit Rational Intonation gamut, proposed by Ibn Sina (980-1037), also known as Avicenna, in the encyclopaedia Kitab al-Shifa, as a fretting of the oud as used in his time. The gamut combines divisions (intervals) derived by combining primes 2, 3, 7, and 13. Thanks to Idin Samimi Mofakham for translation, analysis, and documentation.",
  "scale": [
    "273/256",
    "13/12",
    "9/8",
    "32/27",
    "39/32",
    "81/64",
    "4/3",
    "91/64",
    "13/9",
    "3/2",
    "128/81",
    "13/8",
    "27/16",
    "16/9",
    "91/48",
    "52/27",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "17-JI-13lIbnSina",
  "built_in_group": "Arabic and Persian Theoretical Systems",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "D",
    "D",
    "D",
    "E",
    "E",
    "E",
    "F",
    "G",
    "G",
    "G",
    "A",
    "A",
    "A",
    "B",
    "C",
    "C"
  ],
  "note_colors": [
    "#ff8e8e",
    "#ebd0e0",
    "#e6d7fe",
    "#ffffff",
    "#d0d0d7",
    "#e6d7fe",
    "#ffffff",
    "#ffffff",
    "#ebd0e0",
    "#e6d7fe",
    "#ffffff",
    "#d0d0d7",
    "#e6d7fe",
    "#ffffff",
    "#d0d0d7",
    "#ebd0e0",
    "#e6d7fe"
  ],
  "equivSteps": 17,
  "fundamental": 440,
  "reference_degree": 13,
  "center_degree": 0,
  "rSteps": 3,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
